import { userAppPreferencesDefault } from '../../data/user-app-preferences-default';
import {
    UserAppPreferencesModel
} from '../../models/user-app-preferences.model';
import { OnePointOne } from './1.1';

/**
 * Update media type color defaults
 */
export function fromOnePointOneToOnePointTwo(oldDataModel: UserAppPreferencesModel): UserAppPreferencesModel {
    const newModel = new UserAppPreferencesModel();
    newModel.version = '1.2';
    newModel.reportsPrefs = oldDataModel.reportsPrefs;
    newModel.targetingPrefs = oldDataModel.targetingPrefs;
    newModel.monitoringPrefs = oldDataModel.monitoringPrefs;

    Object.entries(oldDataModel.reportsPrefs.defaultChartColors.mediaTypeColors).forEach(([key, value]) => {
        if (value === OnePointOne[key]) {
            newModel.reportsPrefs.defaultChartColors.mediaTypeColors[key] = userAppPreferencesDefault.reportsPrefs.defaultChartColors.mediaTypeColors[key];
        }
    });
    return newModel;
}
